import { Link } from "react-router-dom";
import { MapPin, Clock, Phone } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_4617f7a1-a0be-47cd-bab6-ee41a0500da1/artifacts/0sc8l5qp_7951d7a5-59a1-479d-b9d9-a4a46051deb5.jpeg";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-slate-900 text-slate-300 mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src={LOGO_URL}
              alt="Namya Health"
              className="h-12 w-12 rounded-lg bg-white object-contain p-1"
            />
            <div className="font-serif-display text-2xl text-white font-semibold">
              Namya Health
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
            Comprehensive care for diabetes, hypertension and high cholesterol
            levels — blending evidence-based medicine with diet and exercise
            guidance.
          </p>
        </div>

        <div>
          <h4 className="text-white font-serif-display text-xl mb-4">Visit Us</h4>
          <div
            data-testid={FOOTER.address}
            className="flex gap-3 text-sm leading-relaxed text-slate-300"
          >
            <MapPin size={18} className="mt-0.5 text-[hsl(var(--primary))] shrink-0" />
            <span>
              Namya Clinic, Shop No. 3<br />
              Sahasrarjuna Circle, Navanagar<br />
              Hubli – 580025, Karnataka
            </span>
          </div>
          <div
            data-testid={FOOTER.hours}
            className="flex gap-3 text-sm mt-4 text-slate-300"
          >
            <Clock size={18} className="mt-0.5 text-[hsl(var(--primary))] shrink-0" />
            <span>
              Consultations: 5:30 PM – 6:30 PM<br />
              Sunday holiday
            </span>
          </div>
          <div className="flex gap-3 text-sm mt-4 text-slate-300">
            <Phone size={18} className="mt-0.5 text-[hsl(var(--primary))] shrink-0" />
            <span>Walk-in & appointments welcome</span>
          </div>
        </div>

        <div>
          <h4 className="text-white font-serif-display text-xl mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/know-your-disease" className="hover:text-white">
                Know Your Disease
              </Link>
            </li>
            <li>
              <Link to="/know-your-medications" className="hover:text-white">
                Know Your Medications
              </Link>
            </li>
            <li>
              <Link to="/diet" className="hover:text-white">
                Diet
              </Link>
            </li>
            <li>
              <Link to="/exercise" className="hover:text-white">
                Exercise
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Namya Health. All rights reserved.</span>
          <span>Information shared here is educational and not a substitute for medical advice.</span>
        </div>
      </div>
    </footer>
  );
}
